<template>
  <div>
    <el-row :gutter="6">
      <el-col :span="0.5">
        <img src="@/svg/home.svg" style="height:26px; width:30px;margin-bottom:4px" />
      </el-col>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }" style="font-size:24px">
          <span>首页</span>
        </el-breadcrumb-item>
        <el-breadcrumb-item style="font-size:24px">{{ firstName }}</el-breadcrumb-item>
        <el-breadcrumb-item style="font-size:24px">{{ metertype }}</el-breadcrumb-item>
        <el-breadcrumb-item style="font-size:24px">{{ meterName }}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
  </div>
</template>
<script>
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['firstName', 'metertype', 'meterName'],
  data() {
    return {}
  }
}
</script>
